export default "__VITE_ASSET__CGnXnjnA__"